import { graphqlApolloClient } from "../graphql-apollo-client"
import { GET_SCHEDULES_BY_ACTIVITY } from "./graphql"

export const activityScheduleService = () => {

  const getSchedulesByActivity = async ({ activityId }) => {
    const result = await graphqlApolloClient.query({
        query: GET_SCHEDULES_BY_ACTIVITY,
        fetchPolicy: "network-only",
        variables: { activityId }
      }
    )
    return result?.data?.getSchedulesByActivity
  }

  return {
    getSchedulesByActivity
  }
}